<template>
  <div class="the-navbar__user-meta flex items-center">
    <div class="text-right leading-tight hidden sm:block">
      <p class="font-semibold">{{ activeUserInfo.displayName }}</p>
      <small
        class="cursor-pointer text-primary"
        v-if="$helper.isMerchant()"
        @click="selectAccount"
      >
        <template v-if="$store.getters[`account/default`]">
          {{ $store.getters["account/default"].text }}
        </template>
        <template v-else> انتخاب اکانت </template>
      </small>
      <small v-else>آنلاین</small>
    </div>
    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
      <div class="con-img ml-3">
        <img
          v-if="activeUserInfo.photoURL"
          key="onlineImg"
          :src="activeUserInfo.photoURL"
          alt="user-img"
          width="40"
          height="40"
          class="rounded-full shadow-md cursor-pointer block"
        />
      </div>

      <vs-dropdown-menu class="vx-navbar-dropdown profile-menu1">
        <ul style="min-width: 9rem">
          <li
            v-if="
              this.$acl.check(this.$router.match('/user-profile').meta.rule)
            "
            class="
              flex
              py-2
              px-4
              cursor-pointer
              hover:bg-primary
              hover:text-white
              opacity-75
            "
            @click="$router.push('/user-profile').catch(() => {})"
          >
            <feather-icon icon="UserIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">پروفایل</span>
          </li>

          <!-- <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white opacity-75"
            @click1="$router.push('/apps/email').catch(() => {})"
          >
            <feather-icon icon="MailIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">پیام ها</span>
          </li>

          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white opacity-75"
            @click1="$router.push('/apps/todo').catch(() => {})"
          >
            <feather-icon icon="CheckSquareIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">کار ها</span>
          </li>

          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white opacity-75"
            @click1="$router.push('/apps/chat').catch(() => {})"
          >
            <feather-icon icon="MessageSquareIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">گفتگو</span>
          </li>

          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white opacity-75"
            @click1="$router.push('/apps/eCommerce/wish-list').catch(() => {})"
          >
            <feather-icon icon="HeartIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">لیست علاقه</span>
          </li> -->

          <vs-divider class="m-1" />

          <li
            class="
              flex
              py-2
              px-4
              cursor-pointer
              hover:bg-primary
              hover:text-white
            "
            @click="logout"
          >
            <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">خروج</span>
          </li>
        </ul>
      </vs-dropdown-menu>
    </vs-dropdown>
    <select-account-popup v-if="$helper.isMerchant()" ref="SelectAccountPopup1" />
  </div>
</template>
<style scoped>
.profile-menu1 {
  right: 168px !important;
}
</style>
<script>
import SelectAccountPopup from "@/views/bpay/components/SelectAccountPopup.vue";
export default {
  data() {
    return {};
  },
  components: {
    SelectAccountPopup,
  },
  computed: {
    activeUserInfo() {
      return this.$store.state.AppActiveUser;
    },
  },
  methods: {
    logout() {
      this.$store.dispatch("auth/Logout");      
      this.$store.reset();
      this.$router.push("/pages/login");
    },
    selectAccount() {
      this.$refs.SelectAccountPopup1.show();
    },
  },
  mounted(){
    this.$helper.selectAccount=this.selectAccount;
  }
};
</script>
